// extracted by mini-css-extract-plugin
module.exports = {"calendarDate":"global_calendarDate__13vyQ"};